import { computed, ref, watch, set } from "vue";
import { ItemStatus, Links, replaceCheckList } from "../../data/template";
import { useGetId, useGetLink, useGetObj } from "../../methods/getAddForm";
import { inject } from "vue";
import { dailylyControlApi } from "@/api/control/dailyControl.api";
import { message } from "ant-design-vue";
import moment from "moment";
import Cookies from "js-cookie";

export default function (props) {
  const uploadUrl = process.env.VUE_APP_NEW_URL + "/comapi/UploadApi";
  const getUploadHeaders = () => {
    const token = Cookies.get("access");
    return token ? { Authorization: "Bearer " + token } : {};
  };
  // uploadHeaders 用 computed ref，token 刷新后自动更新
  const uploadHeaders = computed(() => getUploadHeaders());
  const injectedLink = useGetLink();
  const link = injectedLink || ref(Links.End);
  const id = useGetId() || '';
  const changeTime = (val) => {
    if (moment(val).format("YYYY-MM-DD") === moment().format("YYYY-MM-DD")) {
      formData.value.immediate = true;
    } else {
      formData.value.immediate = false;
    }
  };
  const changeImmediate = (val) => {
    if (val) {
      formData.value.date = moment();
    }
  };

  const formData = ref({
    // 小标题
    title: props.data.itemName,
    //状态：符合/不符合/不适用 1/2/3
    status: -1,
    // 不符合内容，其余传空
    content: "",
    // 不符合上传的图片地址，其余传空
    img: "",
    // 整改期限 不符合传具体日期，其余传空
    date: null,
    // 是否立即整改 不符合传true/false，其余传空
    immediate: false,
    itemName: props.data.itemName,
    itemNo: props.data.itemNo,
  });

  if ( props.data.defaultFormData&&props.data.defaultFormData.isZG) {
    formData.value = props.data.defaultFormData;
  } else if (link.value === Links.Rectification) {
    // 优化初始化逻辑：保留已有数据，仅在缺失时使用默认空值
    const defaultStructure = {
      title: props.data.itemName,
      status: -1,
      content: "",
      img: "",
      date: null,
      immediate: false,
      itemName: props.data.itemName,
      itemNo: props.data.itemNo,
      cause: "",
      changeDate: "",
      measure: "",
      method: "",
      methodImg: "",
      isZG: false,
    };
    const existingData = props.data.defaultFormData || {};
    // 合并数据：以 existingData 为主
    formData.value = { ...defaultStructure, ...existingData };
  }

  const { setDataList } = inject("SetData", { setDataList: null });
  if (setDataList) {
    setDataList(formData.value, props.data.parentName);
  }

  // 监听 props.data.defaultFormData 的变化，实时更新 formData（关键修复）
  watch(
    () => props.data.defaultFormData,
    (newData) => {
      if (newData && Object.keys(newData).length > 0) {
        // 合并更新所有字段
        Object.assign(formData.value, newData);
      }
    },
    { deep: true }
  );

  watch(
    () => link.value,
    () => {
      if (link.value === Links.Check) {
        /**默认符合 */
        formData.value.status = ItemStatus["符合"];
      }
      //   else if (
      //     [Links.Rectification, Links.Examine, Links.End].includes(link.value)
      //   ) {
      //     props.data.status === 2 ? (formData.isConform = "不符合") : null;
      //   }
      //   if ([Links.Examine, Links.End].includes(link.value)) {
      //     props.data.status === 2 ? (isZG.value = true) : null;
      //   }
    }
  ),
    {
      immediate: true,
    };
  function getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }
  function handleCancel() {
    previewVisible.value = false;
  }
  const previewVisible = ref(false);
  const previewImage = ref('');
  const fileList = ref([]);
  const fileList2 = ref([]);
  async function handlePreview (file) {
    const url = file.url || (file.response && file.response.data && file.response.data.file_url) || '';
    if (url && !/\.(png|jpe?g|gif|webp|bmp|svg)(\?.*)?$/i.test(url)) {
      window.open(url, '_blank');
      return;
    }
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    previewImage.value = file.url || file.preview;
    previewVisible.value = true;
  }
  const options = computed(() => {
    return [
      {
        label: "符合",
        value: ItemStatus["符合"],
        disabled: link.value === Links.Plan,
      },
      {
        label: "不符合",
        value: ItemStatus["不符合"],
        disabled: link.value === Links.Plan,
      },
      {
        label: "不适用",
        value: ItemStatus["不适用"],
        disabled: link.value === Links.Plan,
      },
    ];
  });
  const handleChange = (info) => {
    if (info.file.status === "done") {
      // Get this url from response in real world.
      formData.value.img = info.file.response.data.file_url;
      fileList.value = info.fileList;
    }
    if (info.file.status === "error") {
      message.error("upload error");
    }
  };
  const handleChange2 = (info) => {
    if (info.file.status === "uploading") {
      return;
    }
    if (info.file.status === "done") {
      // Get this url from response in real world.
      formData.value.methodImg = info.file.response.data.file_url;
      fileList2.value = info.fileList;
    }
    if (info.file.status === "error") {
      message.error("upload error");
    }
  };
  const getObj = useGetObj();
  const forceRefreshPrint = inject('forceRefreshPrint', () => {});

  async function submit() {
    try {
      const obj = getObj();
      if (obj) {
        formData.value.isZG = true;
        
        // 只有存在 ID 时才调用 API 更新后端 (编辑/整改模式)
        if (id) {
          const oldCheckList = obj.check_list;
          const newCheckList = replaceCheckList(
            oldCheckList,
            formData.value,
            props.data.parentName
          );
          /**替换checklist */
          const params = {
            id,
            check_list: newCheckList,
          };
          await dailylyControlApi.updateForm(params);
          // 更新本地数据，确保打印预览能获取到最新数据
          obj.check_list = newCheckList;
          // 强制刷新打印组件
          forceRefreshPrint();
        }
        
        message.success("提交成功");
      } else {
        return message.error("未找到原始数据");
      }
    } catch (error) {
      message.error("提交失败");
      formData.value.isZG = false;
    }
  }
  return {
    uploadUrl,
    uploadHeaders,
    previewVisible,
    link,
    id,
    changeTime,
    changeImmediate,
    formData,
    fileList,
    previewImage,
    fileList2,
    handlePreview,
    handleCancel,
    options,
    handleChange,
    handleChange2,
    submit,
  };
}
